<template>
    <div class="homeHeader">
        <div class="logoTop">
            <div class="content">
                <div class="logo" @click.stop="onPath('/')">
                    <img src="./images/logo.png" alt="">
                </div>
                <div class="loginBox">
                    <!-- <div class="registered" @click="onRegistered()">注册</div> -->
                    <div class="login" @click="loginShowJump()" v-show="!showphoto">登录/注册</div>
                    <div class="hasLogin" v-show="showphoto">
                        <img @click="goUsercenter()" style="width:42px;height:42px;cursor:pointer;border-radius:50%;margin:auto;" :src="avatarUrl?avatarUrl + '?x-image-process=image/resize,m_fixed,w_50,h_50' : userPhoto" alt='版权登记'/>
                        <div class="hasChild">
                            <div class="child" @click="goUsercenter()">个人中心</div>
                            <div class="child" @click="loginouts()">退出登录</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="navBox">
            <div class="content">
                <div class="item" :class="activeNav == item.path || activeNav == item.name?'active':''" v-for="(item,index) in navList" :key="index">
                    <div @click.stop="onPath(item.path,item)">{{item.name}}</div>
                    <div class="hasChild" v-if="item.children">
                        <div class="child" v-for="(itemC,indexC) in item.children" :key="indexC" @click.stop="onPath(itemC.path,itemC)">
                           <div> {{itemC.name}}</div>
                           <div class="newChild" v-if="itemC.children">
                               <div class="itemS" v-for="(itemS,indexS) in itemC.children" :key="indexS" @click.stop="onPath(itemS.path,itemS)">{{itemS.name}}</div>
                           </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="$store.state.app.showLoginOrRegistter">
            <login @fatherClose="closeLoginMethod" @childFn="parentFn"/>
        </div>
    </div>
</template>

<script>
    import login from '@/views/login.vue'
    import Cookies from "js-cookie";
    import qs from 'qs';
    import {getStore, removeStore, setStore} from '@/libs/storage';
    import axios from 'axios';
    import verifycode from '@/views/vipClip/verification/verifyCode.vue'
    import {_sysGetTime} from "@/api/staticPage.js";
    import moment from 'moment';
    import EventBus from "@/libs/eventBus"
    import {getGsfwUrl} from "@/api/index";

    let currentDate, tempDate, ms = null;
    export default {
        name: "homeHeader",
        components: {
            login
        },
        data() {
            return {
                activeNav: '/',
                navList: [
                    {
                        name: "首页",
                        path: '/'
                    },
                  
                    {
                        name: "版权登记",
                        // path: '/gananPreRegistration'
                        path: '/gananCopyrightRegistration'
                    },
                    /*{
                        name: "版权其他业务",
                        children: [
                            {
                                name: "其他登记申请",
                                open: true,
                                children: [
                                    {
                                        name: "登记证书补发或更换申请",
                                        path: 'http://www.gsbqfw.com/user/copyright-registration/online-registration/supply-change-application',
                                        open: true
                                    },
                                    {
                                        name: "著作权变更或补充登记申请",
                                        path: 'http://www.gsbqfw.com/user/copyright-registration/online-registration/change-supple-application',
                                        open: true
                                    },
                                    {
                                        name: "作品著作权撤销登记申请",
                                        path: 'http://www.gsbqfw.com/user/copyright-registration/online-registration/cancel-register-application',
                                        open: true
                                    },
                                    {
                                        name: "作品著作权转让登记申请",
                                        path: 'http://www.gsbqfw.com/user/copyright-registration/online-registration/transfer-application',
                                        open: true
                                    },
                                    {
                                        name: "作品著作权许可登记申请",
                                        path: 'http://www.gsbqfw.com/user/copyright-registration/online-registration/permit-application',
                                        open: true
                                    },
                                ]
                            },
                            {
                                name: "查档出证",
                                open: true,
                                children: [
                                    {
                                        name: "查档申请",
                                        path: 'http://www.gsbqfw.com/user/copyright-registration/online-registration/check-application',
                                        open: true
                                    },
                                ]
                            },
                            {
                              name: "证书",
                              open: true,
                              children: [
                                {
                                  name: "打印证书",
                                  path: 'http://www.gsbqfw.com/user/copyright-registration/my-registration/unprint-application',
                                  open: true
                                },
                              ]
                            },
                            
                        ]
                    },*/
                    // {
                    //     name: "查档出证",
                    //     children: [
                    //         {
                    //             name: "查档申请",
                    //             path: 'http://www.gsbqfw.com/user/copyright-registration/online-registration/check-application',
                    //             open: true
                    //         },
                    //     ]
                    // },
                  {
                      name: "版权服务",
                      children: [
                          {
                              name: '电子数据存证',
                              path: '/gananElectronic'
                          },
                          {
                              name: '版权预登记',
                              path: '/gananPreRegistration'
                          },
                          {
                              name: '软件著作权登记',
                              path: '/gananSoftwareCopyright'
                          },
                          {
                              name: '版权监测',
                              path: '/gananCopyrightMonitoring'
                          },
                          {
                              name: '法律服务',
                              path: '/gananCopyrightRights'
                          },
                          {
                              name: '侵权取证',
                              path: '/gananWebForensics'
                          }
                        ],
                    },
                    {
                        name: "内容运营",
                        // path: '/gananIpAuth',
                        children: [
                          {
                            name: 'IP授权',
                            path: '/gananIpAuth'
                          },
                          {
                            name: '数字文创',
                            path: 'https://dca.qh-copyright.cn/?tenant_id=1713738930886807552',
                            open: true
                          }
                        ],
                        /*children: [
                            {
                                name: '文化产品',
                                path: '/gananSpecial'
                            },
                            {
                              name: '影视作品',
                              path: '/gananIPlist'
                            }
                        ]*/
                    },
                    {
                        name: "版权资讯",
                        children: [
                            {
                                name: '新闻资讯',
                                path: '/gananNewCenter'
                            },
                            {
                                name: '版权问答',
                                path: '/gananAnswer'
                            }
                        ],
                    },
                    {
                        name: "公示查询",
                         path: 'https://blockchain.qh-copyright.cn/pubPage',
                          open: true
                    },
                    {
                        name: "关于我们",
                        path: '/gananAboutUs'
                    },
                ],
                showphoto: false,
                userPhoto: require('@/assets/head.png'),
            }
        },
        computed: {
            avatarUrl: function () {
                return this.$store.state.avatarUrl
            }
        },
        watch: {
            $route(to, from) {
                if (getStore('accessToken') == '' && this.$route.query.action == 'ipauth') {
                    this.$store.state.app.showLoginOrRegistter = true
                }

                if (to.path == '/gananAboutUs/qianhai' || to.path == '/gananAboutUs/gangan') {
                    this.activeNav = '/gananAboutUs'
                } else if ( to.path == '/gananSoftwareCopyrightUp' || to.path == '/monitoring' || to.path == '/monitor' || to.path == '/gananWebForensicsUp' || to.path == '/gananElectronic' || to.path == '/apply-cert' || to.path == '/gananPreRegistration' || to.path == '/gananSoftwareCopyright' || to.path == '/gananCopyrightMonitoring' || to.path == '/gananCopyrightRights' || to.path == '/gananWebForensics') {
                    this.activeNav = '版权服务'
                }else if (to.path == '/copyrightRegistration') {
                    if (to.fullPath == '/copyrightRegistration?regType=02') {
                        this.activeNav = '版权登记'
                    } else {
                         this.activeNav = '版权服务'
                    }
                    
                }else if (to.path == '/gananNewCenter/indexList' || to.path == '/gananNewCenter/newDetails') {
                    this.activeNav = '/gananNewCenter'
                    
                } else if (to.path == '/gananAnswer/wenist' || to.path == '/gananAnswer/mywenList' || to.path == '/gananAnswer/wenDetails') {
                    this.activeNav = '版权资讯'
                    
                } else if (to.path == '/gananIPlist' || to.path == '/gananIPinfo' || to.path == '/gananProjectList' || to.path == '/gananApplyEquity' || to.path == '/gananSpecial') {
                    this.activeNav = '/gananIpAuth'
                } else {
                    this.activeNav = to.path
                }

                // let menuList = this.navList;
                // let newPath = ''
                // for (let i = 0; i < menuList.length; i++) {
                //     let nowItem = menuList[i];
                //     if (to.path != nowItem.path) {
                //         if (nowItem.children) {
                //             let nowItemChild = nowItem.children;
                //             for (let j = 0; j < nowItemChild.length; j++) {
                //                 if (nowItemChild[j].path == to.path) {
                //                     console.log(231);
                //                     newPath = nowItem.path || nowItem.name;
                //                     break;
                //                 }
                //             }
                //         }
                //     }
                // }
                // this.activeNav = newPath

                this.showphoto = Cookies.get("userInfo") ? true : false;
            }
        },
        created() {
            this.showphoto = Cookies.get("userInfo") ? true : false;
            if (Cookies.get("userInfo")) {
                this.tphoto = JSON.parse(Cookies.get("userInfo")).photo;
                this.$store.state.app.showLoginOrRegistter2 = false
            }
        },
        mounted() {
            EventBus.on('childFn',(photo)=>{
               this.parentFn(photo)
            });
        },
        methods: {
            onActiveNav(index) {
                this.activeNav = index
            },
            onLogin() {
                this.$router.push('/gananLogin')
            },
            onRegistered() {
                this.$router.push('/gananRegistered')
            },
            onPath(path,item) {
                let that = this
              if(path.startsWith('http')){
                window.open(path)
                return;
              }
                if (path && item.open) {
                    this.$store.state.app.otherUrl = path
                    if (Cookies.get("userInfo")) {
                        let gsfData = {
                            url: path
                        }
                        getGsfwUrl(gsfData).then(resOther => {
                            
                            if (resOther.result != path) {
                                window.open(resOther.result,'_blank')
                            } else {
                                toast('暂不可访问')
                            }
                        })
                        // if (Cookies.get("otherToken")) {
                        //     let otherUrl = `${path}?token=${Cookies.get("otherToken")}`
                        //     window.open(otherUrl,'_blank')
                        // } else {
                        //     axios({
                        //         method: 'post',
                        //         url: `http://www.gsbqfw.com:8080/consumer/login?username=${JSON.parse(Cookies.get("userInfo")).gsUserId}&password=${JSON.parse(Cookies.get("userInfo")).gsUserPassword}`,
                        //         withCredentials: false
                        //     }).then(function (resOther) {
                        //         if (resOther.code == 200) {
                        //             Cookies.set("otherToken", JSON.stringify(resOther.data.token),60*60*9)
                        //             let otherUrl = `${path}?token=${resOther.data.token}`
                        //             window.open(otherUrl,'_blank')
                        //         } else {
                        //             toast('暂不可访问')
                        //         }
                                
                        //     }).catch(function (err) {
                        //         toast('暂不可访问')
                        //     });
                        // }

                    } else {
                      console.log("1111111111111" + path)
                        this.$store.state.app.showLoginOrRegistter = true
                    }
                    
                } else if (path) {
                    this.$router.push(path)
                    this.$store.state.app.otherUrl = false
                }  
            },
            loginShowJump(name) {
                this.$store.state.app.showLoginOrRegistter = true
            },
            closeLoginMethod() {
                this.$store.state.app.showLoginOrRegistter = false
            },
            parentFn(payload) {
                this.showphoto = true
                this.tphoto = payload
            },
            loginouts() {
                let _this = this
                let accessToken = getStore('accessToken');
                let username = '';
                if (Cookies.get("userInfo")) {
                    username = JSON.parse(Cookies.get("userInfo")).account ? JSON.parse(Cookies.get("userInfo")).account : '';
                }
                let params = {
                    username: username
                }
                axios({
                    method: 'post',
                    url: this.API_ROOT_UPLOAD + 'logout',
                    data: qs.stringify(params),
                    withCredentials: false,
                    headers: {
                        'accessToken': accessToken
                    }
                }).then(function (response) {
                    console.log(response);
                    if (response.code == 200) {
                        //ucenter退出登录
                        let jscode = response.javascript;
                        _this.callChild(jscode);
                        Cookies.remove('accessToken');
                        Cookies.remove('accessToken', {domain: 'bqj.cn'});
                        Cookies.remove('userInfo');
                        Cookies.remove('otherToken');
                        // 清空打开的页面等数据
                        // removeStore('accessToken')
                        setStore('accessToken', '');
                        _this.showphoto = false
                        _this.$router.push('/');
                        _this.$store.state.app.showPayWay = false
                        _this.$store.state.app.showLoginOrRegistter = false
                        _this.$store.state.app.showLoginOrRegistter2 = false
                        _this.$store.state.app.otherUrl = ''
                        EventBus.emit("logout", 'bbb');
                        EventBus.emit("data-loginout", 'loginout');

                    }
                }).catch(function (err) {
                    console.log(err);
                });
            },
            goUsercenter() {
                this.$router.push({path: '/memberInfo'})
            },
             callChild(jscode) {
                // 传参并指定回调执行函数为onBack
                for (let j = 0, len = jscode.length; j < len; j++) {
                    let script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.src = jscode[j] + '&callback=onBack';
                    document.head.appendChild(script);
                }
            },
        },
        beforeDestroy() {}
    };
</script>

<style lang="less" scoped>
.homeHeader{
    .logoTop{
        background: #fff;
        .content{
            display: flex;
            align-items: center;
            max-width: 1200px;
            margin: auto;
            height: 80px;
            .logo{
                cursor: pointer;
                &img{
                    width: 366px;
                    height: 43px;
                }
            }
            .loginBox{
                margin-left: auto;
                display: flex;
                align-items: center;
                .registered{
                    width: 88px;
                    height: 32px;
                    line-height: 32px;
                    border-radius: 4px;
                    border: 1px solid #E5E5E5;
                    text-align: center;
                    margin-right: 20px;
                    cursor: pointer;
                }
                .login{
                    width: 88px;
                    height: 32px;
                    line-height: 32px;
                    background: #2196F3;
                    border-radius: 4px;
                    border: 1px solid #2196F3;
                    color: #fff;
                    text-align: center;
                    cursor: pointer;
                }
                .hasLogin{
                    position: relative;
                    .hasChild{
                        position: absolute;
                        width: 86px;
                        background: #fff;
                        padding: 8px 15px;
                        z-index: 999;
                        box-shadow: 0px 0px 12px 1px rgba(0, 0, 0, 0.1);
                        border-radius: 8px; 
                        display: none;
                        left: 50%;
                        transform: translate(-50%,0);
                        .child{
                            color: #666666;
                            font-size: 14px;
                            padding: 8px 0;
                            line-height: 1.6;
                            cursor: pointer;
                            &:hover{
                                color: #2196F3;
                            }
                        }
                    }
                    &:hover{
                        background: linear-gradient(180deg, rgba(255, 255, 255, 0.85) 0%, rgba(255, 255, 255, 0.15) 100%);
                        .hasChild{
                            display: block;
                        }
                    }
                }
            }
        }
    }
    
    .navBox{
        background: #5595cb;
        .content{
            display: flex;
            align-items: center;
            max-width: 1200px;
            margin: auto;
            height: 48px;
            .item{
                flex: 1;
                font-size: 14px;
                color: #fff;
                line-height: 48px;
                text-align: center;
                cursor: pointer;
                position: relative;
                .hasChild{
                    position: absolute;
                    width: 100%;
                    background: #fff;
                    padding: 8px 0;
                    z-index: 999;
                    box-shadow: 0px 0px 12px 1px rgba(0, 0, 0, 0.1);
                    border-radius: 0px 0px 8px 8px; 
                    display: none;
                    .child{
                        color: #666666;
                        font-size: 14px;
                        padding: 8px 15px;
                        line-height: 1.6;
                        position: relative;
                        .newChild{
                            position: absolute;
                            left: 100%;
                            width: 140%;
                            background: #fff;
                            color: #666666;
                            font-size: 14px;
                            line-height: 1.6;
                            padding: 8px 0; 
                            top: -8px;
                            display: none;
                            border-radius: 0px 0px 8px 8px;
                            .itemS{
                               padding: 8px 15px; 
                               &:hover {
                                  color: #2196F3; 
                               }
                               &:hover ~ .newChild{
                                  display: block;
                               }
                            }
                        }
                        &:hover{
                            color: #2196F3;
                            .newChild{
                                display: block;
                            }
                        }
                    }
                }
                &:hover{
                    background: linear-gradient(180deg, rgba(255, 255, 255, 0.85) 0%, rgba(255, 255, 255, 0.15) 100%);
                    .hasChild{
                        display: block;
                    }
                }
            }
            .active{
                background: linear-gradient(180deg, rgba(255, 255, 255, 0.85) 0%, rgba(255, 255, 255, 0.15) 100%);
            }
        }
    }
}
</style>
